<template>
  <div class="time-text">{{ time }}</div>
</template>

<script>
export default {
  name: 'tb-clock',
  props: {
    isTwentyFourHour: {
      default: true,
      type: Boolean
    },
    isHourVisible: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      time: ''
    }
  },
  methods: {
    /**
     * @description 10보다 작을 때 0붙여서 반환
     * @param {Number} num
     * @returns {string}
     */
    addZeroWhenLessThanTen (num) {
      return (num > 9) ? num : `0${num}`
    }
  },
  mounted () {
    setInterval(() => {
      const date = new Date()
      const m = this.addZeroWhenLessThanTen(date.getMinutes())
      const s = this.addZeroWhenLessThanTen(date.getSeconds())
      if (this.isHourVisible) {
        let h = this.addZeroWhenLessThanTen(date.getHours())
        if (!this.isTwentyFourHour) {
          let timeText = date.getHours() > 12 ? '오후' : '오전'
          h = `${timeText} ${this.addZeroWhenLessThanTen(date.getHours() % 12)}`
        }
        this.time = `${h}:${m}:${s}`
      } else {
        this.time = `${m}:${s}`
      }
    }, 500)
  }
}
</script>
